import React from "react";
import { useParams } from "react-router-dom";
import { serviceData } from "../../data/ServiceData";
import InquiryForm from "../forms/InquiryForm";

const ServiceLayout = () => {
  const { id } = useParams();
  const service = serviceData.find((s) => s.id === id);

  if (!service) {
    return (
      <div className="py-20 text-xl text-center font-basefont mt-10">
        <h2>Service Not Found</h2>
        <p>Sorry, the requested service could not be found.</p>
      </div>
    );
  }

  return (
    <div className="py-16 bg-bgpalecolor font-basefont mt-10">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="mb-12 lg:mb-16 text-center">
          <h1 className="text-3xl md:text-4xl font-semibold text-basecolor mb-4">
            {service.title}
          </h1>
          {service.mainContent && (
            <div
              className="text-lg text-gray-700 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: service.mainContent }}
            />
          )}
        </div>

        <div className="flex justify-center items-center mb-16">
          <div className="w-full flex justify-center items-center">
            <div className="relative w-full max-w-6xl rounded-lg overflow-hidden shadow-2xl">
              <video
                src={service.vdo}
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover aspect-video"
              />
            </div>
          </div>
        </div>

        {service.featuresTitle && service.features && (
          <div className="mb-12 lg:mb-16">
            <h2 className="text-2xl font-semibold text-basecolor mb-6">
              {service.featuresTitle}
            </h2>
            <ul className="space-y-4 text-gray-700 list-disc list-inside">
              {service.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Property Types Section (if it exists) */}
        {service.propertyTypesTitle && service.propertyTypes && (
          <div className="mb-12 lg:mb-16">
            <h2 className="text-2xl font-semibold text-basecolor mb-6">
              {service.propertyTypesTitle}
            </h2>
            <ul className="space-y-4 text-gray-700 list-disc list-inside">
              {service.propertyTypes.map((type, index) => (
                <li key={index}>{type}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Why Choose Us Section */}
        {service.whyChooseTitle && service.whyChoosePoints && (
          <div className="bg-white rounded-lg shadow-sm p-8 mb-12 lg:mb-16">
            <h2 className="text-2xl font-semibold text-basecolor mb-6">
              {service.whyChooseTitle}
            </h2>
            <ul className="space-y-4 text-gray-700">
              {service.whyChoosePoints.map((point, index) => (
                <li key={index} className="flex items-center">
                  <svg
                    className="w-5 h-5 mr-2 text-basecolor"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Testimonial Section */}
        {service.testimonial && (
          <div className="bg-gray-200 rounded-lg p-8 mb-12 lg:mb-16">
            <h2 className="text-2xl font-semibold text-basecolor mb-4">
              Customer Testimonial
            </h2>
            <blockquote className="text-lg text-gray-800 italic">
              {service.testimonial.quote}
            </blockquote>
            <p className="mt-4 text-gray-600 font-semibold">
              - {service.testimonial.author} | {service.testimonial.designation}
            </p>
          </div>
        )}

        {service?.inquiryFormFields && (
          <>
            {console.log(
              "service?.inquiryFormFields:",
              service?.inquiryFormFields
            )}
            <div className="bg-white rounded-lg shadow-sm p-8">
              <h2 className="text-2xl font-semibold text-basecolor mb-6">
                Inquiry Form
              </h2>
              <p className="text-gray-700 mb-4">
                Contact us today to learn more about our{" "}
                {service.title.toLowerCase()}.
              </p>
              <InquiryForm
                formFields={service.inquiryFormFields}
                serviceId={service.id}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ServiceLayout;
